import React from "react";
import { Route, Routes } from "react-router-dom";
import { CanAccessThisPage } from "Common/RoleVerify";


import MyProfile from "Partials/MyProfile/MyProfile";
import Hotels from "Partials/Universal/Hotels/Hotels";
import EditPromoCode from "Partials/RoomsSettings/PromoCode/EditPromoCode/EditPromoCode";
import AddPromoCode from "Partials/RoomsSettings/PromoCode/AddPromoCode/AddPromoCode";
// import RoomCleaning from "Partials/Universal/HouseKeeping/Components/RoomCleaning/RoomCleaning";
// import Checklist from "Partials/Universal/HouseKeeping/Components/Checklist/Checklist";
// import QrList from "Partials/Universal/HouseKeeping/Components/QrList/QrList";
// import CleaningReport from "Partials/Universal/HouseKeeping/Components/CleaningReport/CleaningReport";
import PurchaseReports from "Partials/Reports/Components/PurchaseReports/PurchaseReports";
import Invoice from "Partials/Reports/Components/PurchaseReports/Components/Invoice";
import StockReport from "Partials/Reports/Components/StockReport/StockReport";
import AddFloor from "Partials/RoomsSettings/Floor/AddFloor/AddFloor";
import EditFloor from "Partials/RoomsSettings/Floor/EditFloor/EditFloor";
import UserSettions from "Partials/Universal/Hotels/Components/Setting/User-Settions";
import CustomerView from "Partials/Universal/Hotels/Customers/Customer/ViewCustomer/CustomerView";
import EditCustomer from "Partials/Universal/Hotels/Customers/Customer/EditCustomers/EditCustomers";
import AddtCustomer from "Partials/Universal/Hotels/Customers/Customer/AddCustomers/AddCustomers";
import AddBed from "Partials/RoomsSettings/BedList/AddBed/AddBed";
import EditBedType from "Partials/RoomsSettings/BedList/EditBed/EditBed";
import AddRoomFacilityType from "Partials/Universal/Hotels/Room Facilites/RoomFacilityType/AddRoomFacilityType/AddRoomFacilityType";
import EditRoomFacilityType from "Partials/Universal/Hotels/Room Facilites/RoomFacilityType/EditRoomFacilityType/EditRoomFacilityType";
import AddRoomFacilityDetail from "Partials/Universal/Hotels/Room Facilites/RoomFacilityDetail/AddRoomFacilityDetail/AddRoomFacilityDetail";
import EditRoomFacilityDetail from 'Partials/Universal/Hotels/Room Facilites/RoomFacilityDetail/EditRoomFacilityDetail/EditRoomFacilityDetail';
import EditRoomSize from "Partials/Universal/Hotels/Room Facilites/RoomSize/EditRoomSize/EditRoomSize";
import AddRoomSize from "Partials/Universal/Hotels/Room Facilites/RoomSize/AddRoomSize/AddRoomSize";
import AddBookingType from "Partials/RoomsSettings/BookingTypeList/AddBooking/AddBookingType";
import EditBookingType from "Partials/RoomsSettings/BookingTypeList/EditBooking/EditBookingType";
import AddRoom from "Partials/RoomsSettings/RoomList/AddRoom/AddRoom";
import EditRoom from "Partials/RoomsSettings/RoomList/EditRoom/EditRoom";
import EditRoomImages from "Partials/RoomsSettings/RoomImages/EditRoomImages/EditRoomImages";
import AddRoomImages from "Partials/RoomsSettings/RoomImages/AddRoomImages/AddRoomImages";
import AddComplementary from "Partials/RoomsSettings/ComplementaryList/AddComplementary/AddComplementary";
import EditComplementary from "Partials/RoomsSettings/ComplementaryList/EditComplementary/EditComplementary";
import AddProduct from "Partials/Universal/ItemsManage/Product/AddProduct/AddProduct";
import EditProduct from "Partials/Universal/ItemsManage/Product/EditProduct/EditProduct";
import AddProductCategory from "Partials/Universal/ItemsManage/CategoryList/AddCategory/AddCategory";
import EditProductCategory from "Partials/Universal/ItemsManage/CategoryList/EditCategory/EditCategory";
import AddSupplier from "Partials/Universal/ItemsManage/Supplier/AddSupplier/AddSupplierList";
import EditSupplier from "Partials/Universal/ItemsManage/Supplier/EditSupplier/EditSupplier";
import AddDestroyed from "Partials/Universal/ItemsManage/DestroyedList/AddDestroyedList/AddDestroyedList";
import EditDestroyed from "Partials/Universal/ItemsManage/DestroyedList/EditDestroyedList/EditDestroyedList";
import EditItemsUnit from "Partials/Universal/ItemsManage/ItemsUnit/EditItemsUnit/EditItemsUnit";
import AddItemsUnit from "Partials/Universal/ItemsManage/ItemsUnit/AddItemsUnit/AddItemsUnit";
import AddFloorAssign from "Partials/RoomsSettings/FloorAssign/AddFloorAssign/AddFloorAssign";
import EditFloorAssign from "Partials/RoomsSettings/FloorAssign/EditFloorAssign/EditFloorAssign";
import AssignRoom from "Partials/RoomsSettings/RoomAssign/AssignRooms/AssignRoom";
import AddTexManagement from "Partials/Universal/Hotels/TaxManagement/AddTaxManagement/AddTaxManagement";
import EditTexManagement from "Partials/Universal/Hotels/TaxManagement/EditTaxManagement/EditTaxManagement";
import AssignRoomFacilities from "Partials/RoomsSettings/AssignRoomFacilities/AssignRoomFacilities";
import AssignRoomOffer from "Partials/RoomsSettings/AssignRoomOffer/CreateRoomOffer/AssignRoomOffer";
import AssignRoomOfferList from "Partials/RoomsSettings/AssignRoomOffer/Components/AssignRoomOfferList";
import CopyAssignRoomOffer from "Partials/RoomsSettings/AssignRoomOffer/CopyAssignRoomOffer/CopyAssignRoomOffer";
import AddWakeUpCall from "Partials/Universal/Hotels/Customers/WakeUpCall/AddWakeUpCall/AddWakeUpCall";
import EditWakeUpCall from "Partials/Universal/Hotels/Customers/WakeUpCall/EditWakeUpCall/EditWakeUpCall";
import EditGuest from "Partials/Universal/Hotels/Customers/guest/EditGuest/EditGuest";
import EditPaymentCurrency from "Partials/Universal/Hotels/PaymentSetting/CurrencyList/EditCurrency/EditPaymentCurrency";
import AddPaymentCurrency from "Partials/Universal/Hotels/PaymentSetting/CurrencyList/AddCurrency/AddPaymentCurrency";
import EditBookingCommission from "Partials/RoomsSettings/BookingCommission/EditBookingCommission/EditBookingCommission";
import AddBookingCommission from "Partials/RoomsSettings/BookingCommission/AddBookingCommission/AddBookingCommission";
import EditPaymentMethod from "Partials/Universal/Hotels/PaymentSetting/PaymentMethod/EditPaymentMethod/EditPaymentMethod";
import AddPaymentMethod from "Partials/Universal/Hotels/PaymentSetting/PaymentMethod/AddPaymentMethod/AddPaymentMethod";
import EditPaymentSetup from "Partials/Universal/Hotels/PaymentSetting/PaymentSetup/EditPaymentSetup/EditPaymentSetup";
import AddPaymentSetup from "Partials/Universal/Hotels/PaymentSetting/PaymentSetup/AddPaymentSetup/AddPaymentSetup";
import AddPurchaseItem from "Partials/Universal/Hotels/PurchaseManagement/PurchaseItem/AddPurchaseItem/AddPurchaseItem";
import EditPurchaseItem from "Partials/Universal/Hotels/PurchaseManagement/PurchaseItem/EditPurchaseItem/EditPurchaseItem";
import RoomBooking from "Partials/Universal/RoomBook/Booking/RoomBooking/RoomBooking";
import ReturnInvoiceListTable from "Partials/Universal/Hotels/PurchaseManagement/ReturnInvoice/ReturnInvoiceView/ReturnInvoiceView";
import PurchaseReturnList from "Partials/Universal/Hotels/PurchaseManagement/PurchaseReturn/PurchaseReturnList";
import EditRoomBooking from "Partials/Universal/RoomBook/Booking/EditRoomBooking/EditRoomBooking";
import ViewRoomBooking from "Partials/Universal/RoomBook/Booking/ViewRoomBooking/ViewRoomBooking";
import CreateRoomCheckIn from "Partials/Universal/RoomBook/RoomCheckIn/CreateRoomCheckIn/CreateRoomCheckIn";
import EditRoomCheckIn from "Partials/Universal/RoomBook/RoomCheckIn/EditRoomCheckIn/EditRoomCheckIn";
import ViedRoomCheckIn from "Partials/Universal/RoomBook/RoomCheckIn/ViewRoomCheckIn/ViewRoomCheckIn";
import RoomCheckOut from "Partials/Universal/RoomBook/RoomCheckOut/RoomCheckOut";
import EditPoolType from "Partials/Universal/Hotels/PoolBooking/PoolType/EditPoolType/EditPoolType";
import AddSwimmingPool from "Partials/Universal/Hotels/PoolBooking/SwimmingPool/AddSwimmingPool/AddSwimmingPool";
import EditSwimmingPool from "Partials/Universal/Hotels/PoolBooking/SwimmingPool/EditSwimmingPool/EditSwimmingPool";
import EditPoolPackage from "Partials/Universal/Hotels/PoolBooking/PoolPackage/EditPoolPackage/EditPoolPackage";
import AddPoolPoolPackage from "Partials/Universal/Hotels/PoolBooking/PoolPackage/AddPoolPackage/AddPoolPackage";
import AddPoolBooking from "Partials/Universal/Hotels/PoolBooking/PoolBooking/AddPoolBooking/AddPoolBooking";
import EditPoolBooking from "Partials/Universal/Hotels/PoolBooking/PoolBooking/EditPoolBooking/EditPoolBooking";
import EditZoneType from "Partials/Universal/Hotels/CarParking/ZoneType/EditZoneType/EditZoneType";
import EditSlot from "Partials/Universal/Hotels/CarParking/SlotList/EditSlot/EditSlot";
import EditVehicleType from "Partials/Universal/Hotels/CarParking/VehicleList/EditVehicleType/EditVehicleType";
import EditSetting from "Partials/Universal/Hotels/CarParking/SettingList/EditSetting/EditSetting";
import AddSetting from "Partials/Universal/Hotels/CarParking/SettingList/AddSetting/AddSetting";
import AddParkingBooking from "Partials/Universal/Hotels/CarParking/CarBooking/AddParkingBooking/AddParkingBooking";
import EditParkingBooking from "Partials/Universal/Hotels/CarParking/CarBooking/EditParkingBooking/EditParkingBooking";
import AddHallSeatPlan from "Partials/Universal/Hotels/EventBooking/HallSeatPlan/AddHallSeatPlan/AddHallSeatPlan";
import EditHallSeatPlan from "Partials/Universal/Hotels/EventBooking/HallSeatPlan/EditHallSeatPlan/EditHallSeatPlan";
import AddHallRoomType from "Partials/Universal/Hotels/EventBooking/HallRoomType/AddHallRoomType/AddHallRoomType";
import EditHallRoomType from "Partials/Universal/Hotels/EventBooking/HallRoomType/EditHallRoomType/EditHallRoomType";
import AddHallBooking from "Partials/Universal/Hotels/EventBooking/HallBooking/AddHallBooking/AddHallBooking";
import EditFoodType from "Partials/Universal/Hotels/FoodBooking/FoodType/EditFoodType/EditFoodType";
import EditFood from "Partials/Universal/Hotels/FoodBooking/FoodList/EditFood/EditFood";
import AddFood from "Partials/Universal/Hotels/FoodBooking/FoodList/AddFood/AddFood";
import EditFoodpackage from "Partials/Universal/Hotels/FoodBooking/Foodpackage/EditFoodpackage/EditFoodpackage";
import EditPFTL from "Partials/Universal/Hotels/FoodBooking/PackageFoodTypeLimit/EditPFTL/EditPFTL";
import AddPFTL from "Partials/Universal/Hotels/FoodBooking/PackageFoodTypeLimit/AddPFTL/AddPFTL";
import AddFoodPakage from "Partials/Universal/Hotels/FoodBooking/Foodpackage/AddFoodPakage/AddFoodPakage";
import AddLaundryProduct from "Partials/Universal/Hotels/Laundry/LaundryProduct/AddLaundryProduct/AddLaundryProduct";
import EditLaundryProduct from "Partials/Universal/Hotels/Laundry/LaundryProduct/EditLaundryProduct/EditLaundryProduct";
import AddLaundryTask from "Partials/Universal/Hotels/Laundry/LaundryTask/AddLaundryTask/AddLaundryTask";
import EditLaundryTask from "Partials/Universal/Hotels/Laundry/LaundryTask/EditLaundryTask/EditLaundryTask";
import AddLaundryItemCost from "Partials/Universal/Hotels/Laundry/LaundryItemCost/AddLaundryItemCost/AddLaundryItemCost";
import EditLaundryItemCost from "Partials/Universal/Hotels/Laundry/LaundryItemCost/EditLaundryItemCost/EditLaundryItemCost";
import AddLaundry from "Partials/Universal/Hotels/Laundry/Laundry/AddLaundry/AddLaundry";
import EditLaundry from "Partials/Universal/Hotels/Laundry/Laundry/EditLaundry/EditLaundry";
import ViewLaundry from "Partials/Universal/Hotels/Laundry/Laundry/ViewLaundry/ViewLaundry";
import ReceiveLaundry from "Partials/Universal/Hotels/Laundry/Laundry/ReceiveLaundry/ReceiveLaundry";
import AddHousekeeping from "Partials/Universal/Hotels/Housekeeping/Housekeeping/AddHousekeeping/AddHousekeeping"
import EditHousekeeping from "Partials/Universal/Hotels/Housekeeping/Housekeeping/EditHousekeeping/EditHousekeeping"
import EditFlight from "Partials/Universal/Hotels/TransportFacility/FlightDetails/EditFlight/EditFlight";
import AddFlight from "Partials/Universal/Hotels/TransportFacility/FlightDetails/AddFlight/AddFlight";
import AddVehicle from "Partials/Universal/Hotels/TransportFacility/VehicleDetails/AddVehicle/AddVehicle";
import EditVehicle from "Partials/Universal/Hotels/TransportFacility/VehicleDetails/EditVehicle/EditVehicle";
import AddVehicleBooking from "Partials/Universal/Hotels/TransportFacility/VehicleBooking/AddVehicleBooking/AddVehicleBooking";
import EditVehicleBooking from "Partials/Universal/Hotels/TransportFacility/VehicleBooking/EditVehicleBooking/EditVehicleBooking";

import EditShift from "Partials/Universal/Hotels/DutyRoster/ShiftList/EditShift";
import AddRoster from "Partials/Universal/Hotels/DutyRoster/DutyRoster/AddRoster/AddRoster";
import EditRoster from "Partials/Universal/Hotels/DutyRoster/DutyRoster/EditRoster/EditRoster";
import AssignEmployee from "Partials/Universal/Hotels/DutyRoster/AssignedEmployee/AddAssignedEmployee/AssignEmployee";
import EditAssignedEmployee from "Partials/Universal/Hotels/DutyRoster/AssignedEmployee/EditAssignedEmployee/EditAssignedEmployee";
import ViewAssignedRoster from "Partials/Universal/Hotels/DutyRoster/AssignedRoster/ViewAssignedRoster/ViewAssignedRoster";
import AddShift from "Partials/Universal/Hotels/DutyRoster/ShiftList/AddShift/AddShift";
import EditHallBooking from "Partials/Universal/Hotels/EventBooking/HallBooking/EditHallBooking/EditHallBooking";
import ViewHallBooking from "Partials/Universal/Hotels/EventBooking/HallBooking/ViewHallBooking/ViewHallBooking";
import EditHallImages from "Partials/Universal/Hotels/EventBooking/HallImages/EditHallImages/EditHallImages";
import AddHallImages from "Partials/Universal/Hotels/EventBooking/HallImages/AddHallImages/AddHallImages";

import AddBlog from "Partials/Blog/BlogList/AddBlog/AddBlog";
import EditBlog from "Partials/Blog/BlogList/EditBlog/EditBlog";
import AddBlogCategory from "Partials/Blog/BlogCategory/AddBlogCategory/AddBlogCategory";
import EditBlogCategory from "Partials/Blog/BlogCategory/EditBlogCategory/EditBlogCategory";
import AddBlogTag from "Partials/Blog/BlogTag/AddBlogTag/AddBlogTag";
import EditBlogTag from "Partials/Blog/BlogTag/EditBlogTag/EditBlogTag";

import AddPage from "Tuning/PagesSettings/AddPage/AddPage";
import EditPage from "Tuning/PagesSettings/EditPage/EditPage";

import InvoicePrint from "Partials/Universal/RoomBook/Booking/BookingList/Components/InvoicePrint";
import InvoicePrintCheckin from "Partials/Universal/RoomBook/RoomCheckIn/RoomCheckInList/Components/InvoicePrint";

import RoomNoFloorAssignEdit from "Partials/RoomsSettings/RoomStatus/RoomNoFloorAssignEdit/RoomNoFloorAssignEdit"

import CheckoutList from "Partials/Universal/RoomBook/RoomCheckOut/CheckOutListing/CheckoutList"


const HotelRoutes = () => {
  const AddRoutesUrl = (url) => `/:parent/${url}`;
  const EditRoutesUrl = (url) => `/:parent/${url}/:id`;

  const CanCreateRoute = (path, element) => (
    <Route
      key={path}
      path={AddRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_create']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );


  const CanEditPageRoute = (path, element) => (
    <Route
      key={path}
      path={EditRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_edit']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );

  const CanViewPageRoute = (path, element) => (
    <Route
      key={path}
      path={EditRoutesUrl(path)}
      element={
        <CanAccessThisPage menu_access={['can_access']}>
          {element}
        </CanAccessThisPage>
      }
    />
  );

  return [
    <Route key="profile" exact path="/my-profile" element={<MyProfile />} />,
    <Route key="profile" exact path="/booking-list/print-invoice/:id" element={<InvoicePrint />} />,
    <Route key="profile" exact path="/check-in/print-invoice/:id" element={<InvoicePrintCheckin />} />,
    <Route key="hotels" exact path="/hotels" element={<Hotels />} />,

    <Route key="purchase-report" exact path="/purchase-report" element={<PurchaseReports />} />,
    <Route key="invoice" exact path="/invoice" element={<Invoice />} />,
    <Route key="stock-report" exact path="/stock-report" element={<StockReport />} />,
    <Route key="user-settions" exact path="/user-settions" element={<UserSettions />} />,

    <Route key="copy-offer" exact path="/:parent/:child/copy-assign-offer/:id" element={<CopyAssignRoomOffer />} />,
    <Route key="add-return-invoice" exact path="/purchase-return-invoice-list/add-return-invoice" element={<PurchaseReturnList />} />,
    <Route key="assign-offer-nested" exact path="/:parent/:child/assign-offer" element={<AssignRoomOffer />} />,
    <Route key="room-check-out" exact path="/room-check-out" element={<RoomCheckOut />} />,
    <Route key="check-out" exact path="check-out/checkout-management" element={<CheckoutList />} />,

    CanEditPageRoute("edit-pool-type", <EditPoolType />),
    CanEditPageRoute("edit-swimming-pool", <EditSwimmingPool />),
    CanEditPageRoute("edit-pool-package", <EditPoolPackage />),
    CanEditPageRoute("edit-pool-booking", <EditPoolBooking />),

    CanCreateRoute("add-swimming-pool", <AddSwimmingPool />),
    CanCreateRoute("add-pool-package", <AddPoolPoolPackage />),
    CanCreateRoute("add-pool-booking", <AddPoolBooking />),

    CanCreateRoute("add-setting", <AddSetting />),
    CanCreateRoute("add-booking", <AddParkingBooking />),

    CanEditPageRoute("edit-slot", <EditSlot />),
    CanEditPageRoute("edit-booking", <EditParkingBooking />),
    CanEditPageRoute("edit-zone-type", <EditZoneType />),
    CanEditPageRoute("edit-vehicle-type", <EditVehicleType />),
    CanEditPageRoute("edit-setting", <EditSetting />),

    CanEditPageRoute("edit-hall-seatplan", <EditHallSeatPlan />),
    CanEditPageRoute("edit-hall-room-type", <EditHallRoomType />),

    CanCreateRoute("add-hall-room-type", <AddHallRoomType />),
    CanCreateRoute("add-hall-seatplan", < AddHallSeatPlan />),
    CanCreateRoute("add-hall-booking", <AddHallBooking />),
    CanEditPageRoute("edit-hall-booking", <EditHallBooking />),
    CanViewPageRoute("view-hall-booking", <ViewHallBooking />),
    CanCreateRoute("add-hall-images", <AddHallImages />),
    CanEditPageRoute("edit-hall-image", <EditHallImages />),

    CanEditPageRoute("edit-food-categories", <EditFoodType />),
    CanEditPageRoute("edit-food", <EditFood />),
    CanEditPageRoute("edit-food-package", <EditFoodpackage />),
    CanEditPageRoute("edit-package-food-type-limit", <EditPFTL />),

    CanCreateRoute("add-package-food-type-limit", <AddPFTL />),
    CanCreateRoute("add-food-package", <AddFoodPakage />),
    CanCreateRoute("add-food", <AddFood />),

    CanCreateRoute("add-laundry-product", <AddLaundryProduct />),
    CanCreateRoute("add-laundry-task", <AddLaundryTask />),
    CanCreateRoute("add-laundry-item-cost", <AddLaundryItemCost />),
    CanCreateRoute("add-laundry", <AddLaundry />),

    CanEditPageRoute("edit-laundry", <EditLaundry />),
    CanEditPageRoute("view-laundry", <ViewLaundry />),
    CanEditPageRoute("receive-laundry", <ReceiveLaundry />),
    CanEditPageRoute("edit-laundry-item-cost", <EditLaundryItemCost />),
    CanEditPageRoute("edit-laundry-task", <EditLaundryTask />),
    CanEditPageRoute("edit-laundry-product", <EditLaundryProduct />),

    CanCreateRoute("add-purchase-item", <AddPurchaseItem />),

    CanEditPageRoute("view-return-invoice", <ReturnInvoiceListTable />),
    CanEditPageRoute("edit-purchase-item", <EditPurchaseItem />),

    CanCreateRoute("room-booking", <RoomBooking />),

    CanEditPageRoute("update-booking", <EditRoomBooking />),
    CanViewPageRoute("view-booking", <ViewRoomBooking />),
    CanCreateRoute("create-check-in", <CreateRoomCheckIn />),
    CanEditPageRoute("update-checkin", <EditRoomCheckIn />),
    CanEditPageRoute("create-checkin", <EditRoomCheckIn />),
    CanViewPageRoute("view-checkin", <ViedRoomCheckIn />),

    CanEditPageRoute("edit-promo-code", <EditPromoCode />),
    CanCreateRoute("add-promo-code", <AddPromoCode />),

    CanCreateRoute("add-booking-commission", <AddBookingCommission />),
    CanEditPageRoute("edit-booking-commission", <EditBookingCommission />),

    CanEditPageRoute("edit-floor-assign", <EditFloorAssign />),

    CanCreateRoute("assign-floor", <AddFloorAssign />),
    CanCreateRoute("assign-room", <AssignRoom />),
    CanCreateRoute("assign-room-facilities", <AssignRoomFacilities />),
    CanCreateRoute("assign-room-offer", <AssignRoomOfferList />),

    CanCreateRoute("add-bed", <AddBed />),
    CanEditPageRoute("edit-bed", <EditBedType />),

    CanCreateRoute("add-booking-type", <AddBookingType />),
    CanEditPageRoute("edit-booking-type", <EditBookingType />),

    CanCreateRoute("add-payment-method", <AddPaymentMethod />),
    CanCreateRoute("add-payment-setup", <AddPaymentSetup />),

    CanEditPageRoute("edit-payment-method", <EditPaymentMethod />),
    CanEditPageRoute("edit-payment-setup", <EditPaymentSetup />),

    CanCreateRoute("add-tax", <AddTexManagement />),
    CanEditPageRoute("edit-tax", <EditTexManagement />),

    CanCreateRoute("add-complementary", <AddComplementary />),
    CanEditPageRoute("edit-complementary", <EditComplementary />),

    CanCreateRoute("add-floor", <AddFloor />),
    CanEditPageRoute("edit-floor", <EditFloor />),

    CanCreateRoute("add-room-image", <AddRoomImages />),
    CanCreateRoute("add-room", <AddRoom />),

    CanEditPageRoute("edit-room", <EditRoom />),
    CanEditPageRoute("edit-room-image", <EditRoomImages />),

    CanCreateRoute("add-room-facilites", <AddRoomFacilityType />),
    CanCreateRoute("add-room-facilites-detail", <AddRoomFacilityDetail />),

    CanEditPageRoute("edit-room-facilites", <EditRoomFacilityType />),
    CanEditPageRoute("edit-room-facility-detail", <EditRoomFacilityDetail />),

    CanEditPageRoute("edit-room-size", <EditRoomSize />),
    CanCreateRoute("add-room-size", <AddRoomSize />),

    CanCreateRoute("add-items-list", <AddProduct />),
    CanCreateRoute("add-category", <AddProductCategory />),

    CanEditPageRoute("edit-item", <EditProduct />),
    CanEditPageRoute("edit-category", <EditProductCategory />),

    CanCreateRoute("add-supplier", <AddSupplier />),
    CanEditPageRoute("edit-supplier", <EditSupplier />),

    CanCreateRoute("add-destroyed-list", <AddDestroyed />),
    CanEditPageRoute("edit-destroyed-list", <EditDestroyed />),

    CanCreateRoute("add-unit-items", <AddItemsUnit />),
    CanEditPageRoute("edit-unit-items", <EditItemsUnit />),

    CanEditPageRoute("view-customer", <CustomerView />),
    CanEditPageRoute("edit-customer", <EditCustomer />),

    CanCreateRoute("add-customer", <AddtCustomer />),

    CanEditPageRoute("edit-currency", <EditPaymentCurrency />),
    CanCreateRoute("add-currency", <AddPaymentCurrency />),

    CanCreateRoute("add-wake-up-call", <AddWakeUpCall />),
    CanEditPageRoute("edit-wake-up-call", <EditWakeUpCall />),

    CanEditPageRoute("edit-Guest", <EditGuest />),

    CanCreateRoute("add-housekeeping", <AddHousekeeping />),
    CanEditPageRoute("edit-housekeeping", <EditHousekeeping />),

    CanCreateRoute("add-flight", <AddFlight />),
    CanEditPageRoute("edit-flight", <EditFlight />),

    CanCreateRoute("add-vehicle", <AddVehicle />),
    CanEditPageRoute("edit-vehicle", <EditVehicle />),

    CanCreateRoute("create-vehicle-booking", <AddVehicleBooking />),
    CanEditPageRoute("edit-vehicle-booking", <EditVehicleBooking />),

    CanCreateRoute("add-shift", <AddShift />),
    CanEditPageRoute("edit-shift", <EditShift />),

    CanCreateRoute("add-roster", <AddRoster />),
    CanEditPageRoute("edit-roster", <EditRoster />),

    <Route key="assign-employees" exact path="/:parent/assign-employees" element={
      <CanAccessThisPage menu_access={['can_edit']}>
        <AssignEmployee />
      </CanAccessThisPage>
    } />,

    CanEditPageRoute("edit-roster-assignment", <EditAssignedEmployee />),
    CanEditPageRoute("view-roster-assignment", <ViewAssignedRoster />),

    // ── Blog ──────────────────────────────────────────
    CanCreateRoute("add-blog", <AddBlog />),
    CanEditPageRoute("edit-blog", <EditBlog />),

    CanCreateRoute("add-blog-category", <AddBlogCategory />),
    CanEditPageRoute("edit-blog-category", <EditBlogCategory />),

    CanCreateRoute("add-blog-tag", <AddBlogTag />),
    CanEditPageRoute("edit-blog-tag", <EditBlogTag />),

    // ── Pages ─────────────────────────────────────────
    CanCreateRoute("add-page", <AddPage />),
    CanEditPageRoute("edit-page", <EditPage />),

    CanEditPageRoute("room-no-floor-assign-edit", <RoomNoFloorAssignEdit />),

    CanViewPageRoute("checkout-management", <CheckoutList />),


  ];
};

export default HotelRoutes;